module.exports = __webpack_public_path__ + "img/wire-1.f74988dc.jpg";